import { Classroom } from "@/entities/classroom";

export function sortClassroomsById(classrooms: Classroom[]) {
  if (!classrooms || !classrooms.length) return [];
  return [...classrooms].sort((a, b) =>
    a.data.id.localeCompare(b.data.id, "en", { numeric: true })
  );
}

export function sortClassroomsByName(classrooms: Classroom[]) {
  if (!classrooms || !classrooms.length) return [];

  return [...classrooms].sort((a, b) =>
    a.data.name.localeCompare(b.data.name, undefined, { numeric: true })
  );
}

/**
 * ダブルクォート内のカンマを無視して教室名をパースする。
 * ダブルクォートのエスケープ ("") も処理する。
 * 例: `"大阪,京都教室",東京教室` → ["大阪,京都教室", "東京教室"]
 * 例: `"教室""A""",教室B` → ["教室\"A\"", "教室B"]
 */
export function parseClassroomNames(input: string): string[] {
  if (!input.trim()) return [];

  const result: string[] = [];
  let current = "";
  let inQuotes = false;
  let i = 0;

  while (i < input.length) {
    const char = input[i];

    if (char === '"') {
      // 次の文字も " の場合はエスケープされたダブルクォート
      if (inQuotes && input[i + 1] === '"') {
        current += '"';
        i += 2;
        continue;
      }
      inQuotes = !inQuotes;
    } else if (char === "," && !inQuotes) {
      if (current.trim()) {
        result.push(current.trim());
      }
      current = "";
    } else {
      current += char;
    }
    i++;
  }

  if (current.trim()) {
    result.push(current.trim());
  }
  return result;
}
